var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "settings_backup_restore"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3228_409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3228_409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings_backup_restore_2",
    d: "M10 11.6667C9.54167 11.6667 9.14931 11.5035 8.82292 11.1771C8.49653 10.8507 8.33333 10.4583 8.33333 10C8.33333 9.54167 8.49653 9.14931 8.82292 8.82292C9.14931 8.49653 9.54167 8.33333 10 8.33333C10.4583 8.33333 10.8507 8.49653 11.1771 8.82292C11.5035 9.14931 11.6667 9.54167 11.6667 10C11.6667 10.4583 11.5035 10.8507 11.1771 11.1771C10.8507 11.5035 10.4583 11.6667 10 11.6667ZM10 17.5C8.06944 17.5 6.39583 16.8646 4.97917 15.5938C3.5625 14.3229 2.75 12.7361 2.54167 10.8333H4.25C4.44444 12.2778 5.08681 13.4722 6.17708 14.4167C7.26736 15.3611 8.54167 15.8333 10 15.8333C11.625 15.8333 13.0035 15.2674 14.1354 14.1354C15.2674 13.0035 15.8333 11.625 15.8333 10C15.8333 8.375 15.2674 6.99653 14.1354 5.86458C13.0035 4.73264 11.625 4.16667 10 4.16667C9.04167 4.16667 8.14583 4.38889 7.3125 4.83333C6.47917 5.27778 5.77778 5.88889 5.20833 6.66667H7.5V8.33333H2.5V3.33333H4.16667V5.29167C4.875 4.40278 5.73958 3.71528 6.76042 3.22917C7.78125 2.74306 8.86111 2.5 10 2.5C11.0417 2.5 12.0174 2.69792 12.9271 3.09375C13.8368 3.48958 14.6285 4.02431 15.3021 4.69792C15.9757 5.37153 16.5104 6.16319 16.9062 7.07292C17.3021 7.98264 17.5 8.95833 17.5 10C17.5 11.0417 17.3021 12.0174 16.9062 12.9271C16.5104 13.8368 15.9757 14.6285 15.3021 15.3021C14.6285 15.9757 13.8368 16.5104 12.9271 16.9062C12.0174 17.3021 11.0417 17.5 10 17.5Z",
    fill: "#89AFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.da91623d17597cbafdc790a91e752788.svg";
export { ForwardRef as ReactComponent };